export enum GameCancellationPolicy {
  REFUND = 'REFUND',
  NO_REFUND = 'NO_REFUND',
  WALLET_CREDIT = 'WALLET_CREDIT',
}

export enum GameCancellationReason {
  NO_SHOW = 'NO_SHOW',
  WEATHER = 'WEATHER',
  VENUE_ISSUE = 'VENUE_ISSUE',
  ADMIN_ERROR = 'ADMIN_ERROR',
  OTHER = 'OTHER',
}

export class GameCancellationDto {
  id: string;
  gameId: number;
  policy: GameCancellationPolicy;
  reason?: GameCancellationReason;
  reasonText?: string;
  adminMemberId?: string;
  adminEmail?: string;
  createdAt: string;
}
